import { IconWithText } from 'common/icon/icon-with-text.js';
import { IconNameV1 } from 'common/icon/iconV1.js';

export interface GeneralHeaderInformationComponentProps {
  icon: IconNameV1;
  title: string;
  status?: string;
}

export const GeneralHeaderInformationComponent = ({
  headers,
}: {
  headers: GeneralHeaderInformationComponentProps[];
}) => {
  return (
    <div className="u-flex u-md-mT-sm u-sm-flexCol" style={{ gap: '10px 50px' }}>
      {headers
        .filter((h) => !!h.status)
        .map((header) => {
          const { icon, title, status } = header;
          return (
            <IconWithText key={status} classes="svg-fill-textSlate" icon={icon}>
              <h4 className="u-mT-0 u-mB-0">{title}</h4>
              <p className="small u-mT-0 u-mB-0">{status}</p>
            </IconWithText>
          );
        })}
    </div>
  );
};
